import React, { FC } from 'react';

import { CanDisable } from '@modernloop/shared/helper-components';
import { Card, CardContent, Stack, Typography } from '@mui/material';

interface Props {
  title?: string | React.ReactNode;
  description?: React.ReactNode;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const SettingsCard: FC<Props> = ({ title, description, children, disabled }) => {
  return (
    <CanDisable disabled={!!disabled}>
      <Card variant="outlined">
        <CardContent>
          <Stack rowGap={2.5}>
            {title ? <Typography variant="h5">{title}</Typography> : null}
            {description && <Typography color="text.secondary">{description}</Typography>}
            {children}
          </Stack>
        </CardContent>
      </Card>
    </CanDisable>
  );
};
